// AUTO-GENERATED — do not edit by hand.
// Source of truth: functions/emailTemplates/registry.js
// Regenerate with: node scripts/gen-email-template-defaults.mjs
/* eslint-disable */
export const EMAIL_TEMPLATE_DEFAULTS = [
  {
    "id": "user_property_intake_confirmation",
    "audience": "customer",
    "category": "property_lifecycle",
    "displayName": "Property intake — customer confirmation",
    "description": "Sent to the paying user who submits the new-property intake form (\"We're setting up your property\").",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph (may contain HTML)."
      },
      {
        "path": "propertyName",
        "type": "string",
        "description": "The property the user submitted."
      },
      {
        "path": "eta",
        "type": "string",
        "description": "Typical turnaround copy, e.g. \"3–5 working days\"."
      },
      {
        "path": "productName",
        "type": "string",
        "description": "Product name used in the sign-off."
      }
    ],
    "defaultSubject": "We're setting up your property",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.55;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"8\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;margin:14px 0;\">\n        <tr><td><strong>Property</strong></td><td>{{ propertyName }}</td></tr>\n        <tr><td><strong>Status</strong></td><td>Queued for build</td></tr>\n        <tr><td><strong>Typical turnaround</strong></td><td>{{ eta }}</td></tr>\n      </table>\n      <p style=\"font-size:14px;color:#475569;\">\n        We'll email you again as soon as your dashboard is ready. Until then,\n        the property will appear on your dashboard with a “Building” status.\n      </p>\n      <p style=\"font-size:13px;color:#64748b;margin-top:24px;\">\n        Thanks,<br/>The {{ productName }} team\n      </p>\n    </body></html>\n  ",
    "sampleData": {
      "title": "We're setting up your property",
      "intro": "Thanks — we've received your intake for <strong>Example Farm</strong> and queued it for build on <strong>Ecological Intelligence - Land Health System</strong>.",
      "propertyName": "Example Farm",
      "productName": "Ecological Intelligence - Land Health System",
      "eta": "3–5 working days"
    }
  },
  {
    "id": "admin_property_intake_received",
    "audience": "admin",
    "category": "property_lifecycle",
    "displayName": "Property intake — admin notification",
    "description": "Sent to admins when a user submits the new-property intake form. Includes the full form contents.",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      },
      {
        "path": "propertyName",
        "type": "string",
        "description": "Property name (used in the subject line)."
      }
    ],
    "defaultSubject": "New property intake — {{ propertyName }}",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "New property intake submitted",
      "propertyName": "Example Farm",
      "intro": "A user has submitted the new-property intake form on <strong>Ecological Intelligence - Land Health System</strong>. Marcus's pipeline will pick this up on the next discovery poll. The full form contents are below.",
      "tableRows": "\n        <tr><td><strong>Property name</strong></td><td>Example Farm</td></tr>\n        <tr><td><strong>Property ID</strong></td><td><code>example_farm</code></td></tr>\n        <tr><td><strong>Submitted by</strong></td><td>jane@example-farm.co.uk</td></tr>\n        <tr><td><strong>User UID</strong></td><td><code>sampleUid123</code></td></tr>\n        <tr><td><strong>Submitted at (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n        <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria</td></tr>\n        <tr><td><strong>Approximate size</strong></td><td>120 ha</td></tr>\n      "
    }
  },
  {
    "id": "admin_new_user_signup",
    "audience": "admin",
    "category": "accounts",
    "displayName": "New user signup",
    "description": "Sent to admins when a new (non-admin) user document is created.",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      }
    ],
    "defaultSubject": "New user signup",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "New user signed up",
      "intro": "A new user has signed up to <strong>Ecological Intelligence - Land Health System</strong>.",
      "tableRows": "\n        \n    <tr><td><strong>Name</strong></td><td>Jane Grower</td></tr>\n    <tr><td><strong>Email</strong></td><td>jane@example-farm.co.uk</td></tr>\n    <tr><td><strong>Phone</strong></td><td>+44 7700 900123</td></tr>\n    <tr><td><strong>Organisation</strong></td><td>Example Farm Ltd</td></tr>\n    <tr><td><strong>Job title</strong></td><td>Owner</td></tr>\n    <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria, CA11 0AA, United Kingdom</td></tr>\n  \n        <tr><td><strong>User ID</strong></td><td><code>sampleUid123</code></td></tr>\n        <tr><td><strong>Signup date (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n        <tr><td><strong>Subscription / access</strong></td><td>Founding Associate — £50/month (paid, active)</td></tr>\n        <tr><td><strong>Profile complete</strong></td><td>Yes</td></tr>\n      "
    }
  },
  {
    "id": "admin_user_promoted_to_admin",
    "audience": "admin",
    "category": "security",
    "displayName": "User promoted to admin",
    "description": "Security alert sent to admins when a user is granted the admin role.",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      }
    ],
    "defaultSubject": "Security: user promoted to admin",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "User promoted to administrator",
      "intro": "A user account was granted <strong>admin</strong> on <strong>Ecological Intelligence - Land Health System</strong>. Review in Firebase / Admin dashboard.",
      "tableRows": "\n    <tr><td><strong>Name</strong></td><td>Jane Grower</td></tr>\n    <tr><td><strong>Email</strong></td><td>jane@example-farm.co.uk</td></tr>\n    <tr><td><strong>Phone</strong></td><td>+44 7700 900123</td></tr>\n    <tr><td><strong>Organisation</strong></td><td>Example Farm Ltd</td></tr>\n    <tr><td><strong>Job title</strong></td><td>Owner</td></tr>\n    <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria, CA11 0AA, United Kingdom</td></tr>\n  \n      <tr><td><strong>User ID</strong></td><td><code>sampleUid123</code></td></tr>\n      <tr><td><strong>Role</strong></td><td>admin</td></tr>\n    \n            <tr><td><strong>Previous role</strong></td><td>user</td></tr>\n            <tr><td><strong>Event time (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n          "
    }
  },
  {
    "id": "admin_subscription_override_granted",
    "audience": "admin",
    "category": "security",
    "displayName": "Access override granted",
    "description": "Security alert sent to admins when a user is given a subscription override (paywall bypass).",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      }
    ],
    "defaultSubject": "Security: admin access override granted",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "Admin access override granted",
      "intro": "A user was given <strong>subscription override</strong> (bypass paywall) on <strong>Ecological Intelligence - Land Health System</strong>.",
      "tableRows": "\n    <tr><td><strong>Name</strong></td><td>Jane Grower</td></tr>\n    <tr><td><strong>Email</strong></td><td>jane@example-farm.co.uk</td></tr>\n    <tr><td><strong>Phone</strong></td><td>+44 7700 900123</td></tr>\n    <tr><td><strong>Organisation</strong></td><td>Example Farm Ltd</td></tr>\n    <tr><td><strong>Job title</strong></td><td>Owner</td></tr>\n    <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria, CA11 0AA, United Kingdom</td></tr>\n  \n      <tr><td><strong>User ID</strong></td><td><code>sampleUid123</code></td></tr>\n      <tr><td><strong>Role</strong></td><td>user</td></tr>\n    \n            <tr><td><strong>Override reason</strong></td><td>Beta tester</td></tr>\n            <tr><td><strong>Event time (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n          "
    }
  },
  {
    "id": "admin_subscription_override_revoked",
    "audience": "admin",
    "category": "security",
    "displayName": "Access override removed",
    "description": "Security alert sent to admins when a user’s subscription override is removed.",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      }
    ],
    "defaultSubject": "Security: admin access override removed",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "Admin access override removed",
      "intro": "Subscription <strong>override was removed</strong> for this user on <strong>Ecological Intelligence - Land Health System</strong>. They now follow normal subscription rules.",
      "tableRows": "\n    <tr><td><strong>Name</strong></td><td>Jane Grower</td></tr>\n    <tr><td><strong>Email</strong></td><td>jane@example-farm.co.uk</td></tr>\n    <tr><td><strong>Phone</strong></td><td>+44 7700 900123</td></tr>\n    <tr><td><strong>Organisation</strong></td><td>Example Farm Ltd</td></tr>\n    <tr><td><strong>Job title</strong></td><td>Owner</td></tr>\n    <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria, CA11 0AA, United Kingdom</td></tr>\n  \n      <tr><td><strong>User ID</strong></td><td><code>sampleUid123</code></td></tr>\n      <tr><td><strong>Role</strong></td><td>user</td></tr>\n    \n            <tr><td><strong>Subscription status</strong></td><td>Founding Associate — £50/month (paid, active)</td></tr>\n            <tr><td><strong>Event time (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n          "
    }
  },
  {
    "id": "admin_subscription_active",
    "audience": "admin",
    "category": "billing",
    "displayName": "Subscription activated",
    "description": "Sent to admins when a user’s paid subscription becomes active.",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      }
    ],
    "defaultSubject": "Subscription activated",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "Subscription now active",
      "intro": "A user's paid subscription is <strong>active</strong> on <strong>Ecological Intelligence - Land Health System</strong>.",
      "tableRows": "\n    <tr><td><strong>Name</strong></td><td>Jane Grower</td></tr>\n    <tr><td><strong>Email</strong></td><td>jane@example-farm.co.uk</td></tr>\n    <tr><td><strong>Phone</strong></td><td>+44 7700 900123</td></tr>\n    <tr><td><strong>Organisation</strong></td><td>Example Farm Ltd</td></tr>\n    <tr><td><strong>Job title</strong></td><td>Owner</td></tr>\n    <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria, CA11 0AA, United Kingdom</td></tr>\n  \n      <tr><td><strong>User ID</strong></td><td><code>sampleUid123</code></td></tr>\n      <tr><td><strong>Role</strong></td><td>user</td></tr>\n    \n            <tr><td><strong>Subscription</strong></td><td>Founding Associate — £50/month (paid, active)</td></tr>\n            <tr><td><strong>Stripe subscription</strong></td><td>sub_1234567890</td></tr>\n            <tr><td><strong>Event time (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n          "
    }
  },
  {
    "id": "admin_subscription_past_due",
    "audience": "admin",
    "category": "billing",
    "displayName": "Subscription past due",
    "description": "Sent to admins when a user’s subscription payment fails (past due).",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      }
    ],
    "defaultSubject": "Billing: payment failed — past due",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "Payment failed (past due)",
      "intro": "A subscription is <strong>past due</strong> on <strong>Ecological Intelligence - Land Health System</strong>. Follow up on payment or access.",
      "tableRows": "\n    <tr><td><strong>Name</strong></td><td>Jane Grower</td></tr>\n    <tr><td><strong>Email</strong></td><td>jane@example-farm.co.uk</td></tr>\n    <tr><td><strong>Phone</strong></td><td>+44 7700 900123</td></tr>\n    <tr><td><strong>Organisation</strong></td><td>Example Farm Ltd</td></tr>\n    <tr><td><strong>Job title</strong></td><td>Owner</td></tr>\n    <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria, CA11 0AA, United Kingdom</td></tr>\n  \n      <tr><td><strong>User ID</strong></td><td><code>sampleUid123</code></td></tr>\n      <tr><td><strong>Role</strong></td><td>user</td></tr>\n    \n            <tr><td><strong>Subscription</strong></td><td>Past due — payment issue</td></tr>\n            <tr><td><strong>Stripe customer</strong></td><td>cus_1234567890</td></tr>\n            <tr><td><strong>Event time (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n          "
    }
  },
  {
    "id": "admin_subscription_cancelling",
    "audience": "admin",
    "category": "billing",
    "displayName": "Subscription cancelling",
    "description": "Sent to admins when a user cancels at period end (still active until then).",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      }
    ],
    "defaultSubject": "Billing: subscription cancelling",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "Subscription set to cancel",
      "intro": "A user has <strong>cancelled at period end</strong> on <strong>Ecological Intelligence - Land Health System</strong> (still active until then).",
      "tableRows": "\n    <tr><td><strong>Name</strong></td><td>Jane Grower</td></tr>\n    <tr><td><strong>Email</strong></td><td>jane@example-farm.co.uk</td></tr>\n    <tr><td><strong>Phone</strong></td><td>+44 7700 900123</td></tr>\n    <tr><td><strong>Organisation</strong></td><td>Example Farm Ltd</td></tr>\n    <tr><td><strong>Job title</strong></td><td>Owner</td></tr>\n    <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria, CA11 0AA, United Kingdom</td></tr>\n  \n      <tr><td><strong>User ID</strong></td><td><code>sampleUid123</code></td></tr>\n      <tr><td><strong>Role</strong></td><td>user</td></tr>\n    \n            <tr><td><strong>Subscription</strong></td><td>Cancelling — access until period end</td></tr>\n            <tr><td><strong>Stripe subscription</strong></td><td>sub_1234567890</td></tr>\n            <tr><td><strong>Event time (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n          "
    }
  },
  {
    "id": "admin_subscription_cancelled",
    "audience": "admin",
    "category": "billing",
    "displayName": "Subscription ended",
    "description": "Sent to admins when a user’s subscription is cancelled.",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      }
    ],
    "defaultSubject": "Billing: subscription ended",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "Subscription ended",
      "intro": "A user's subscription is <strong>cancelled</strong> on <strong>Ecological Intelligence - Land Health System</strong>.",
      "tableRows": "\n    <tr><td><strong>Name</strong></td><td>Jane Grower</td></tr>\n    <tr><td><strong>Email</strong></td><td>jane@example-farm.co.uk</td></tr>\n    <tr><td><strong>Phone</strong></td><td>+44 7700 900123</td></tr>\n    <tr><td><strong>Organisation</strong></td><td>Example Farm Ltd</td></tr>\n    <tr><td><strong>Job title</strong></td><td>Owner</td></tr>\n    <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria, CA11 0AA, United Kingdom</td></tr>\n  \n      <tr><td><strong>User ID</strong></td><td><code>sampleUid123</code></td></tr>\n      <tr><td><strong>Role</strong></td><td>user</td></tr>\n    \n            <tr><td><strong>Subscription</strong></td><td>Cancelled</td></tr>\n            <tr><td><strong>Event time (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n          "
    }
  },
  {
    "id": "admin_stripe_dispute_opened",
    "audience": "admin",
    "category": "billing",
    "displayName": "Stripe dispute opened",
    "description": "Sent to admins when a chargeback / dispute is opened in Stripe.",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      }
    ],
    "defaultSubject": "Billing: Stripe charge dispute opened",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "Stripe dispute opened",
      "intro": "A <strong>chargeback / dispute</strong> was opened in Stripe for a customer on <strong>Ecological Intelligence - Land Health System</strong>.",
      "tableRows": "\n    <tr><td><strong>Name</strong></td><td>Jane Grower</td></tr>\n    <tr><td><strong>Email</strong></td><td>jane@example-farm.co.uk</td></tr>\n    <tr><td><strong>Phone</strong></td><td>+44 7700 900123</td></tr>\n    <tr><td><strong>Organisation</strong></td><td>Example Farm Ltd</td></tr>\n    <tr><td><strong>Job title</strong></td><td>Owner</td></tr>\n    <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria, CA11 0AA, United Kingdom</td></tr>\n  \n      <tr><td><strong>User ID</strong></td><td><code>sampleUid123</code></td></tr>\n      <tr><td><strong>Role</strong></td><td>user</td></tr>\n    \n            <tr><td><strong>Dispute ID</strong></td><td>dp_1234567890</td></tr>\n            <tr><td><strong>Status</strong></td><td>needs_response</td></tr>\n            <tr><td><strong>Amount</strong></td><td>50.00 gbp</td></tr>\n            <tr><td><strong>Opened at (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n          "
    }
  },
  {
    "id": "admin_stripe_dispute_closed",
    "audience": "admin",
    "category": "billing",
    "displayName": "Stripe dispute closed",
    "description": "Sent to admins when a Stripe dispute is closed.",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      }
    ],
    "defaultSubject": "Billing: Stripe dispute closed",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "Stripe dispute closed",
      "intro": "A Stripe <strong>dispute was closed</strong> for this customer on <strong>Ecological Intelligence - Land Health System</strong>.",
      "tableRows": "\n    <tr><td><strong>Name</strong></td><td>Jane Grower</td></tr>\n    <tr><td><strong>Email</strong></td><td>jane@example-farm.co.uk</td></tr>\n    <tr><td><strong>Phone</strong></td><td>+44 7700 900123</td></tr>\n    <tr><td><strong>Organisation</strong></td><td>Example Farm Ltd</td></tr>\n    <tr><td><strong>Job title</strong></td><td>Owner</td></tr>\n    <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria, CA11 0AA, United Kingdom</td></tr>\n  \n      <tr><td><strong>User ID</strong></td><td><code>sampleUid123</code></td></tr>\n      <tr><td><strong>Role</strong></td><td>user</td></tr>\n    \n            <tr><td><strong>Closed at (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n            <tr><td><strong>Outcome / reason</strong></td><td>won</td></tr>\n          "
    }
  },
  {
    "id": "admin_stripe_refund",
    "audience": "admin",
    "category": "billing",
    "displayName": "Stripe refund processed",
    "description": "Sent to admins when a refund is recorded in Stripe.",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      }
    ],
    "defaultSubject": "Billing: Stripe refund processed",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "Refund processed",
      "intro": "A <strong>refund</strong> was recorded in Stripe for this customer on <strong>Ecological Intelligence - Land Health System</strong>.",
      "tableRows": "\n    <tr><td><strong>Name</strong></td><td>Jane Grower</td></tr>\n    <tr><td><strong>Email</strong></td><td>jane@example-farm.co.uk</td></tr>\n    <tr><td><strong>Phone</strong></td><td>+44 7700 900123</td></tr>\n    <tr><td><strong>Organisation</strong></td><td>Example Farm Ltd</td></tr>\n    <tr><td><strong>Job title</strong></td><td>Owner</td></tr>\n    <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria, CA11 0AA, United Kingdom</td></tr>\n  \n      <tr><td><strong>User ID</strong></td><td><code>sampleUid123</code></td></tr>\n      <tr><td><strong>Role</strong></td><td>user</td></tr>\n    \n            <tr><td><strong>Refund amount</strong></td><td>50.00 gbp</td></tr>\n            <tr><td><strong>Recorded at (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n          "
    }
  },
  {
    "id": "admin_user_profile_completed",
    "audience": "admin",
    "category": "accounts",
    "displayName": "Profile completed",
    "description": "Sent to admins when a user finishes their onboarding contact details.",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      }
    ],
    "defaultSubject": "Profile completed — contact details ready",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "User completed their profile",
      "intro": "A user finished onboarding contact details on <strong>Ecological Intelligence - Land Health System</strong>.",
      "tableRows": "\n    <tr><td><strong>Name</strong></td><td>Jane Grower</td></tr>\n    <tr><td><strong>Email</strong></td><td>jane@example-farm.co.uk</td></tr>\n    <tr><td><strong>Phone</strong></td><td>+44 7700 900123</td></tr>\n    <tr><td><strong>Organisation</strong></td><td>Example Farm Ltd</td></tr>\n    <tr><td><strong>Job title</strong></td><td>Owner</td></tr>\n    <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria, CA11 0AA, United Kingdom</td></tr>\n  \n      <tr><td><strong>User ID</strong></td><td><code>sampleUid123</code></td></tr>\n      <tr><td><strong>Role</strong></td><td>user</td></tr>\n    \n            <tr><td><strong>Completed at (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n            <tr><td><strong>Subscription / access</strong></td><td>Founding Associate — £50/month (paid, active)</td></tr>\n          "
    }
  },
  {
    "id": "admin_corporate_enquiry",
    "audience": "admin",
    "category": "sales",
    "displayName": "Corporate ESG enquiry",
    "description": "Sent to admins when a user enquires about the Corporate ESG & Sustainability Reporting plan.",
    "variableSchema": [
      {
        "path": "title",
        "type": "string",
        "description": "Heading shown at the top of the email."
      },
      {
        "path": "intro",
        "type": "html",
        "raw": true,
        "description": "Intro paragraph. May contain HTML (rendered as-is)."
      },
      {
        "path": "tableRows",
        "type": "html",
        "raw": true,
        "description": "Precomputed detail-table rows. May contain HTML (rendered as-is)."
      },
      {
        "path": "displayName",
        "type": "string",
        "description": "Enquirer name (used in the subject line)."
      }
    ],
    "defaultSubject": "Corporate ESG plan enquiry — {{ displayName }}",
    "defaultHtml": "\n    <!DOCTYPE html><html><body style=\"font-family:system-ui,sans-serif;line-height:1.5;color:#1e293b;\">\n      <h2 style=\"color:#043132;\">{{ title }}</h2>\n      <p>{{{ intro }}}</p>\n      <table cellpadding=\"6\" style=\"border-collapse:collapse;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;\">\n        {{{ tableRows }}}\n      </table>\n    </body></html>\n  ",
    "sampleData": {
      "title": "New corporate ESG plan enquiry",
      "displayName": "Jane Grower",
      "intro": "A user has enquired about the <strong>Corporate ESG &amp; Sustainability Reporting</strong> plan on <strong>Ecological Intelligence - Land Health System</strong>. Their details are below — reply to <a href=\"mailto:jane@example-farm.co.uk\">jane@example-farm.co.uk</a> to follow up.",
      "tableRows": "\n      \n    <tr><td><strong>Name</strong></td><td>Jane Grower</td></tr>\n    <tr><td><strong>Email</strong></td><td>jane@example-farm.co.uk</td></tr>\n    <tr><td><strong>Phone</strong></td><td>+44 7700 900123</td></tr>\n    <tr><td><strong>Organisation</strong></td><td>Example Farm Ltd</td></tr>\n    <tr><td><strong>Job title</strong></td><td>Owner</td></tr>\n    <tr><td><strong>Address</strong></td><td>Hill Top Farm, Penrith, Cumbria, CA11 0AA, United Kingdom</td></tr>\n  \n      <tr><td><strong>User ID</strong></td><td><code>sampleUid123</code></td></tr>\n      <tr><td><strong>Subscription / access</strong></td><td>Founding Associate — £50/month (paid, active)</td></tr>\n      <tr><td><strong>Submitted at (UTC)</strong></td><td>2026-05-26T09:30:00.000Z</td></tr>\n      <tr><td><strong>Source</strong></td><td>checkout_page</td></tr>\n      <tr><td><strong>Message</strong></td><td>We'd like to discuss group reporting across 12 estates.</td></tr>\n    "
    }
  }
];

export default EMAIL_TEMPLATE_DEFAULTS;
